<div class="animate-pulse">
  <div [ngClass]="mediaClass"
  ></div>
</div>
